import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star } from "lucide-react";

function Stars({ value }) {
  return (
    <span className="inline-flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`h-3.5 w-3.5 ${n <= value ? "fill-amber-400 text-amber-400" : "text-muted-foreground/40"}`} />)}
    </span>
  );
}

export default function PartnerFeedbackPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard/feedback").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="partner-feedback-page">
      <div className="mb-6">
        <div className="text-xs font-bold uppercase tracking-widest text-primary">Quality</div>
        <h1 className="font-heading font-black text-4xl tracking-tight">Partner Feedback</h1>
        <p className="text-muted-foreground text-sm">Customer reviews and average ratings for your logistics partners.</p>
      </div>

      {!data ? (
        <div className="py-16 text-center text-muted-foreground">Loading…</div>
      ) : (
        <div className="grid md:grid-cols-3 gap-6">
          <div className="border border-border bg-card p-6" data-testid="feedback-avg">
            <div className="text-xs uppercase tracking-wide text-muted-foreground">Average Partner Rating</div>
            <div className="flex items-center gap-3 mt-3">
              <div className="font-mono-num font-black text-5xl">{data.average_rating ?? "—"}</div>
              {data.average_rating != null && <div><Stars value={Math.round(data.average_rating)} /><div className="text-xs text-muted-foreground mt-1">{data.total_feedback} review{data.total_feedback === 1 ? "" : "s"}</div></div>}
            </div>
            {data.partners.length > 0 && (
              <div className="mt-6 space-y-2">
                <div className="text-[11px] uppercase tracking-widest text-muted-foreground">Partner Leaderboard</div>
                {data.partners.map((p) => (
                  <div key={p.vendor_name} className="flex items-center justify-between text-sm" data-testid={`top-partner-${p.vendor_name}`}>
                    <span className="truncate max-w-[140px]">{p.vendor_name}</span>
                    <span className="flex items-center gap-2"><Stars value={Math.round(p.average_rating)} /><span className="font-mono-num text-xs text-muted-foreground">{p.average_rating} ({p.count})</span></span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="md:col-span-2 border border-border bg-card">
            <div className="px-4 py-3 border-b border-border text-xs uppercase tracking-widest text-muted-foreground">Recent Reviews</div>
            <div className="divide-y divide-border max-h-[32rem] overflow-y-auto">
              {data.recent.length === 0 && <div className="p-8 text-center text-muted-foreground text-sm">No customer feedback yet. Mark orders delivered and send the feedback link to start collecting reviews.</div>}
              {data.recent.map((f) => (
                <div key={f.id} className="p-4" data-testid={`feedback-item-${f.order_number}`}>
                  <div className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-2"><Stars value={f.rating} /><span className="text-sm font-medium">{f.vendor_name || "—"}</span></div>
                    <span className="text-[11px] text-muted-foreground font-mono-num">{f.order_number} · {new Date(f.created_at).toLocaleDateString()}</span>
                  </div>
                  {f.comment && <p className="text-sm text-muted-foreground italic mt-1">"{f.comment}"</p>}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
